import { render, staticRenderFns } from "./loaderPage.vue?vue&type=template&id=40e966f4&scoped=true"
import script from "./loaderPage.vue?vue&type=script&lang=js"
export * from "./loaderPage.vue?vue&type=script&lang=js"
import style0 from "./loaderPage.vue?vue&type=style&index=0&id=40e966f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e966f4",
  null
  
)

export default component.exports